import FJActionConstant from "../../constant/FJActionConstant";

const initState = {
  couldCopy: false,
  couldPaste: false,
}

export default function (state = initState, action) {
  switch (action.type) {
    case FJActionConstant.UPDATE_COPY_STATUS:
      return {
        ...state,
        couldCopy: action.couldCopy,
      }
    case FJActionConstant.UPDATE_PASTE_STATUS:
      return {
        ...state,
        couldPaste: action.couldPaste,
      }
    default:
      return state;
  }
}